
// If you want only numbers, keep labels simple.
// You can expand labels later.
export const SDG_LABELS: Record<number, string> = {
  1: "No Poverty",
  2: "Zero Hunger",
  3: "Good Health and Well-being",
  4: "Quality Education",
  5: "Gender Equality",
  6: "Clean Water and Sanitation",
  7: "Affordable and Clean Energy",
  8: "Decent Work and Economic Growth",
  9: "Industry, Innovation and Infrastructure",
  10: "Reduced Inequalities",
  11: "Sustainable Cities and Communities",
  12: "Responsible Consumption and Production",
  13: "Climate Action",
  14: "Life Below Water",
  15: "Life on Land",
  16: "Peace, Justice and Strong Institutions",
  17: "Partnerships for the Goals",
};

// Matches your file naming: E-WEB-Goal-01.png ... 17.png
export const sdgIconSrc = (goal: number) =>
  `/images/sdgs/icons/E-WEB-Goal-${String(goal).padStart(2, "0")}.png`;

export type SdgSelectProps = {
  value?: number | null;                 // selected goal (1..17)
  onChange?: (goal: number | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
};

export type AddSdgsDialogProps = {
  value?: number | null;
  onChange?: (sdg: number | null) => void;
};